import { Component, OnInit } from "@angular/core";

import { FormControl, Validators } from "@angular/forms";
import { FileInput } from "ngx-custom-material-file-input";
import { AdminService } from "../../admin/admin.service";
import { DatasetListingService } from "src/app/dataset-listing/dataset-listing.service";
import { SnackbarService } from "src/app/core/snackbar.service";
import { DialogRef } from "@angular/cdk/dialog";
import { MatDialogRef } from "@angular/material/dialog";


@Component({
  selector: 'mood-import-data-dialog',
  templateUrl: 'import-dataset-dialog.component.html',
  styleUrls: ['import-dataset-dialog.component.scss']
})
export class ImportDatasetFileDialogComponent implements OnInit {
  public datasetFileControl = new FormControl<FileInput | undefined>(undefined, [Validators.required]);

  public jsonContent?: any;

  constructor(private _dialogRef: MatDialogRef<ImportDatasetFileDialogComponent>, private _adminService: AdminService, private _snackbarService: SnackbarService, private _dataListingService: DatasetListingService) { }

  ngOnInit(): void {}


  public async processInputFile() {
    // TODO: Set error messages
    if (!this.datasetFileControl.valid) return;

    const datasetJsonValue = this.datasetFileControl.value?.files[0];

    if (!datasetJsonValue) return;

    this.jsonContent = JSON.parse(await datasetJsonValue.text());
  }

  public get importButtonDisabled() {
    return this.datasetFileControl.invalid || !this.jsonContent;
  }

  public async importDatasetFile() {
    await this._adminService.importDatasetFile(this.jsonContent!);

    const datasetId = this.jsonContent['id'];

    await this._dataListingService.updateDatasetById(datasetId, this.jsonContent)

    this._snackbarService.openSuccessMessage("Dataset configuration imported");

    this._dialogRef.close(datasetId);
  }


  closeDialog() {
    this._dialogRef.close();
  }
}
